<template>


  <div class="menu-container w-100 d-print-none">
    <b-navbar toggleable="md" class="col-lg-12" type="dark" id="f-menu">

      <b-container>
        <b-navbar-brand href="#" class="pl-4">
          <router-link :to="{name:'Home'}">
            <img id="f-logo" class="col-lg-12" :src="findAttributeOnSiteInfo('icon')" alt="">
          </router-link>
        </b-navbar-brand>


        <div class="py-3">
          <b-navbar-toggle class="bg-primary" target="nav-collapse"></b-navbar-toggle>
        </div>

        <b-collapse id="nav-collapse" is-nav class="text-center bg-primary py-2 custom-border-rounded-nav mt-1">

          <b-navbar-nav class="text-center w-100" style="margin: 0 100px 0 0">
            <MainMenu/>
          </b-navbar-nav>

        </b-collapse>
      </b-container>

    </b-navbar>

  </div>

</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import MainMenu from './MainMenu'

export default {
  name: "Nav6",
  components: {MainMenu},
  data() {
    return {}
  },
  computed: {
    getBaseUrl() {
      return axios.defaults.baseURL.replace('api', '')
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.getElementById("f-menu").style.backgroundColor = "var(--primary)";
        document.getElementById("f-menu").style.minHeight = "0";
        document.getElementById("f-logo").style.top = "48px";
        let texts = document.querySelectorAll('.nav-link a');
        texts.forEach(text => {
          text.style.color = '#fff';
        });
      } else {
        document.getElementById("f-menu").style.backgroundColor = "transparent";
        document.getElementById("f-menu").style.minHeight = "0";
        document.getElementById("f-logo").style.top = "13px";
        let texts = document.querySelectorAll('.nav-link a');
        texts.forEach(text => {
          text.style.color = 'var(--primary)';
        });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('SiteInfo/getSiteInfos')
  }
};
</script>

<style scoped>
.menu-container {
  display: flex;
  flex-direction: row;
  height: max-content;
}

@media screen and (max-width: 767px) {
  .menu-container {
    justify-content: right;
  }
}

a {
  text-decoration: none;
  color: var(--primary);
  font-size: 20px;
}

a:hover {
  text-decoration: none;
  color: black;

}

#f-menu {
  overflow: hidden;
  transition: 0.4s;
  position: fixed;
  top: 0;
  z-index: 5;
}

#f-logo {
  width: 100px;
  position: fixed;
  transition: 0.4s;
  top: 20px;
  z-index: 99;
}

.custom-border-rounded-nav {
  border-radius: 80px;
}

</style>